<template>
  <div class="radio-group">
    <label class="radio-card">
      <input
        type="radio"
        value="yes"
        :name="name"
        :checked="modelValue === 'yes'"
        @change="$emit('update:modelValue', 'yes')"
      />
      <span>{{ yesLabel }}</span>
    </label>

    <label class="radio-card">
      <input
        type="radio"
        value="no"
        :name="name"
        :checked="modelValue === 'no'"
        @change="$emit('update:modelValue', 'no')"
      />
      <span>{{ noLabel }}</span>
    </label>
  </div>
</template>

<script setup>
defineProps({
  modelValue: {
    type: String,
    default: 'yes', // preselected
  },
  name: {
    type: String,
    default: '',
  },
  yesLabel: {
    type: String,
    default: 'Yes',
  },
  noLabel: {
    type: String,
    default: 'No',
  },
})

defineEmits(['update:modelValue'])
</script>
